<template>
  <div style="display: flex; align-items: flex-start">
    <sidebar style="margin-right: 20px; max-width: 200px" />
    <el-card style="width: 100%">
      <div
        slot="header"
        class="clearfix"
      >
        <span>Számlák</span>
      </div>
      <table-filter
        v-if="config"
        :config="config"
        action="invoice/fetchAllRaw"
      />
      <ntax-invoice-list />
    </el-card>
  </div>
</template>

<script>
  import NtaxInvoiceList from '../../components/ntax/invoices/List';
  import TableFilter from '../.././components/TableFilter';
  import Sidebar from '../.././components/ntax/Sidebar';

  export default {
    components: {
      NtaxInvoiceList,
      TableFilter,
      Sidebar,
    },
    data() {
      return {
        downloadLoading: false,
        config: null,
      };
    },
    async mounted() {
      await this.setConfig();
    },
    methods: {
      async setConfig() {
        let invoiceBooks = await axios.get('api/invoice-books/raw');
        this.config = [
          {
            type: 'text',
            name: 'invoice_number',
            label: 'Szamlaszám',
            defaultSearch: true,
          },
          {
            type: 'select',
            options: invoiceBooks,
            name: 'invoice_book_id',
            label: 'Számlatömb',
            labelCallback: book => book && `${book.name}` || '',
            valueKey: 'id',
          },
          {
            type: 'dateRange',
            name: 'delivery_date',
            label: 'Teljesítési időszak',
          },
          {
            type: 'multipleRemoteSelect',
            name: 'customer_id',
            label: 'Vevő',
            labelCallback: partner => partner && `#${partner.id} ${partner.company.name}` || '',
            valueKey: 'id',
            remoteSearchParam: 'name',
            remoteAction: 'partner/search',
          },
          {
            type: 'text',
            name: 'ntaxCode',
            label: 'NTAX kód',
          },
          {
            type: 'select',
            options: [
              {
                label: 'Igen',
                ntax_exported: 1
              },
              {
                label: 'Nem',
                ntax_exported: 0
              },
            ],
            name: 'ntax_exported',
            label: 'Exportált',
            labelCallback: status => status.label,
            valueKey: 'ntax_exported',
          },
        ];
      }
    },
  };
</script>
